import SandboxEdit from "./SandboxEdit";

export default function RHSandboxPage() {
  return <SandboxEdit></SandboxEdit>;
}
